import type { ReactHydrationStats } from '@atlaskit/react-ufo/config';

export const getReactHydrationStats = (): ReactHydrationStats | undefined => {
	if (typeof window === 'undefined' || !window.__HYDRATABLE__) {
		return undefined;
	}
	return {
		successful: !window.__HYDRATION_ERRORS__?.length,
		warningCount: 0,
		minWarningComponentDepth: 0,
		maxWarningComponentDepth: 0,
	};
};
